
<template>
  <!-- 区服管理 -->
  <div :class="['app-container', { 'bdc-list-page': isBdc, 'bdc-operate-aide-page': isBdc }]">
    <div class="chart-container">
      <el-row :gutter="20">
        <!-- 区服列表 -->
        <el-col :span="24" style="margin-bottom:20px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>区服列表</h5>
              </span>
            </div>
            <div>
              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="adddivshow">添加服务器</el-button>
              <el-button slot="reference" size="mini" icon="el-icon-refresh" :loading="tongbuloading" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="tongbuqufu">同步服务器数据</el-button>
              <el-select v-model="ServerVersions" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:150px" @change="shaixuanServerVersions">
                <el-option label="全部版本" value="" />
                <el-option v-for="selectvalue in ServerVersion" :key="selectvalue.text" :label="selectvalue.text" :value="selectvalue.value" />
              </el-select>
              <el-select v-model="ServerStates" size="mini" placeholder="" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px;width:100px" @change="shaixuanServerStates">
                <el-option label="全部状态" value="" />
                <el-option v-for="selectvalue in ServerState" :key="selectvalue.text" :label="selectvalue.text" :value="selectvalue.value" />
              </el-select>
              <date-picker ref="datepicker" format="yyyy-MM-dd" type="daterange" size="mini" width="240px" style="float:left;margin-bottom:10px" />
              <el-input v-model="serverNames" size="mini" style="width:150px;float:left;margin-left:15px !important;margin-top:10px;margin-bottom:10px" placeholder="服务器名称模糊查询" />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun">查询</el-button>

              <!-- <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event)" />
              </div> -->
              <!--  添加按钮  -->
              <!-- <el-dropdown style="float:right;margin: 10px;cursor: pointer;" trigger="click" size="small" placement="bottom-start">
                <el-button icon="el-icon-more" size="mini" plain>更多操作</el-button>
                <el-dropdown-menu slot="dropdown" class="more-dropdown">
                  <el-dropdown-item @click.native="exportExcel($event)">
                    <svg-icon icon-class="download" style="width: 16px;height: 16px;margin-right: 2px" />
                    下载数据</el-dropdown-item>
                  <el-dropdown-item @click.native="batchEdit">
                    <svg-icon icon-class="edit_channel" style="width: 16px;height: 16px;margin-right: 2px" />
                    批量编辑</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <div style="float:right;margin-right:10px;cursor: pointer;margin-left:10px">
                <el-button size="mini" style="font-size: 12px;padding:5px 15px;margin-top:10px;" @click="batchEdit"><svg-icon icon-class="edit_channel" style="width: 12px;height: 12px;margin-right: 5px" />批量编辑</el-button>
                <el-button v-if="!isBdc" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;margin-top:10px;" @click="exportExcel($event)" title="下载" />
              </div>
              <el-table :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'3px 6px !important'}" :data="tableData.slice((currentPage-1)*sizePage,currentPage*sizePage)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1 tb-edit2'" style="width: 100%" border @filter-change="filterplatformType" v-loading="listLoading" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <el-table-column prop="gameId" label="游戏ID" width="80" />
                <el-table-column prop="gameName" label="游戏名称" width="150" />
                <el-table-column prop="name" label="服务器名称" />
                <el-table-column prop="version" label="服务器版本" width="120" :filters="ServerVersion" :filter-multiple="false" column-key="version" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | versions(ServerVersion) }}
                  </template>
                </el-table-column>
                <el-table-column prop="mergeBeforeId" label="合服前服务器ID" />
                <el-table-column prop="mergeAfterId" label="合服后服务器ID" />
                <el-table-column prop="openTimeStr" label="服务器开服时间" width="120" />
                <el-table-column prop="closeTimeStr" label="服务器关服时间" width="120" />
                <el-table-column prop="mergeTimeStr" label="服务器合服时间" width="120" />
                <el-table-column prop="status" label="服务器状态" width="110" :filters="ServerState" :filter-multiple="false" column-key="status" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <span v-if="isBdc" :class="serverStatusTagClass(scope.row[scope.column.property])">{{ scope.row[scope.column.property] | statuss(ServerState) }}</span>
                    <template v-else>{{ scope.row[scope.column.property] | statuss(ServerState) }}</template>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-muted" @click="zidingyishijianupdate(scope.$index, scope.row)">编辑</el-button>
                      <el-button type="text" class="bdc-table-op-danger" @click="zidingyishijiandelete(scope.$index, scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button size="mini" @click="exportExcel($event)" />
                </template>
                <pagination v-show="dataLength > 0" :auto-scroll="false" :background="!isBdc" :total="dataLength" :page.sync="currentPage" :limit.sync="sizePage" :page-sizes="[10, 15, 20, 30, 50]" :class="isBdc ? 'bdc-table-pagination' : ''" />
              </bdc-table-footer>

              <el-table id="xiazaishijian" style="display: none;" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData" class="tb-edit tb-edit1">
                <el-table-column prop="gameId" label="游戏ID" width="80" />
                <el-table-column prop="gameName" label="游戏名称" width="120" />
                <el-table-column prop="name" label="服务器名称" />
                <el-table-column prop="version" label="服务器版本" width="120">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | versions(ServerVersion) }}
                  </template>
                </el-table-column>
                <el-table-column prop="mergeBeforeId" label="合服前服务器ID" />
                <el-table-column prop="mergeAfterId" label="合服后服务器ID" />
                <el-table-column prop="openTimeStr" label="服务器开服时间" width="150" />
                <el-table-column prop="closeTimeStr" label="服务器关服时间" width="150" />
                <el-table-column prop="mergeTimeStr" label="服务器合服时间" width="150" />
                <el-table-column prop="status" label="服务器状态" width="110">
                  <template slot-scope="scope">
                    <span v-if="isBdc" :class="serverStatusTagClass(scope.row[scope.column.property])">{{ scope.row[scope.column.property] | statuss(ServerState) }}</span>
                    <template v-else>{{ scope.row[scope.column.property] | statuss(ServerState) }}</template>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
        </el-col>
        <!-- 区服分组 -->
        <el-col :span="24" style="margin-bottom:20px;background:#fff" v-if="currentGame.serverGroupSwitch">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <div>
                <h5>区服分组</h5>
              </div>
              <div style="color:rgb(153, 153, 153);font-size:14px;float:left;line-height:20px">
                <div>区服分组用于统一管理项目内的区服筛选规则，将直接影响该项目下所有数据报表页面的区服筛选组件。分组仅作用于筛选逻辑，不会修改区服的基础配置，请在明确区服分组规则后谨慎添加或调整</div>
              </div>
            </div>
            <div>

              <el-button slot="reference" size="mini" icon="el-icon-circle-plus-outline" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="editGroup()">新建分组</el-button>
              <el-button slot="reference" size="mini" icon="el-icon-refresh" :loading="groupBuildLoading" style="margin-left:1%;float:left;margin-top:10px;margin-bottom:10px" @click="queryGroupListRebuild">更新分组数据</el-button>
              <el-input v-model="groupNames" size="mini" style="width:150px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="分组名称模糊查询" clearable />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="queryGroupList" :loading="groupLoading">查询</el-button>

              <el-table :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'3px 6px !important'}" :data="groupTableData.slice((pagination.pageNo-1)*pagination.pageSize,pagination.pageNo*pagination.pageSize)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1 tb-edit2'" style="width: 100%" border v-loading="groupLoading" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <el-table-column prop="groupName" label="分组名称" width="150" />
                <el-table-column prop="groupType" label="分组类型" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row[scope.column.property] == 1">自动分组</span>
                    <span v-else> 未分组 </span>
                  </template>
                </el-table-column>
                <el-table-column prop="version" label="分组规则" width="200">
                  <template slot-scope="scope">
                    区服ID范围：{{ scope.row['serverIdStart']}} ~ {{ scope.row['serverIdEnd']}}
                  </template>
                </el-table-column>
                <el-table-column prop="serverCount" label="区服数量" width="120">
                  <template slot-scope="scope">
                    <el-link :underline="false" type="primary" @click="serverDetail(scope.row)">{{scope.row[scope.column.property]}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="serverIdsPreview" label="包含区服" min-width="120" />
                <el-table-column prop="updateTime" label="更新时间" width="180" />
                <el-table-column prop="updateUserName" label="更新人" width="110" />
                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-muted" @click="editGroup(scope.row)">编辑</el-button>
                      <el-button type="text" class="bdc-table-op-danger" @click="deleteGroup(scope.row)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block">
                <pagination v-show="pagination.totalSize > 0" :auto-scroll="false" :background="!isBdc" :total="pagination.totalSize" :page.sync="pagination.pageNo" :limit.sync="pagination.pageSize" :page-sizes="[10, 15, 20, 30, 50]" :class="isBdc ? 'bdc-table-pagination' : ''" />
              </div>
            </div>
          </div>
        </el-col>

      </el-row>

      <!-- 分组新增编辑弹窗 -->
      <el-dialog append-to-body :title="groupForm.id?'编辑分组':'新建分组'" :visible.sync="groupDialogVisible" width="430px" top="10vh" :close-on-click-modal="false">
        <el-form ref="groupForm" :rules="groupRules" :model="groupForm" label-width="130px">
          <div style="margin:16px 20px 20px">
            <el-radio v-model="groupForm.groupType" :label="1">自动分组</el-radio>
            <!-- <el-radio v-model="radio" label="2">备选项</el-radio> -->
          </div>
          <el-form-item label="分组名称：" prop="groupName">
            <el-input v-model="groupForm.groupName" size="small" style="width:265px" placeholder="请输入分组名称" maxlength="20" show-word-limit />
          </el-form-item>
          <el-form-item label="区服ID范围：" required>
            <el-col :span="10">
              <el-form-item prop="serverIdStart">
                <el-input-number size="small" v-model="groupForm.serverIdStart" style="width:100%" :max="groupForm.serverIdEnd || Infinity" :step="1" step-strictly placeholder="起始ID" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align:center">～</el-col>
            <el-col :span="10">
              <el-form-item prop="serverIdEnd">
                <el-input-number size="small" v-model="groupForm.serverIdEnd" :min="groupForm.serverIdStart || -Infinity" :step="1" step-strictly placeholder="结束ID" controls-position="right" style="width:100%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-form-item>
          <div v-if="groupForm.id" class="tip-group"><i class="el-icon-info tip-icon"></i>修改分组规则后，区服归属将按新规则自动调整。</div>
          <div v-else class="tip-group"><i class="el-icon-info tip-icon"></i>自动分组仅支持纯数字区服ID。新开启的区服将根据分组的区服ID范围，自动归入对应分组，无需人工维护。</div>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="submitGroup" :loading="groupOptLoading">确认</el-button>
            <el-button @click="groupDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 区服数量 -->
      <el-dialog append-to-body :title="groupDetailTitle" :show-close="false" :visible.sync="groupDetailVisible" width="980px" :close-on-click-modal="false">
        <el-table :data="groupDetailTableData" :row-style="{ height: '44px', color: '#666' }" :header-cell-style="{background:'#F7F7F7', height: '44px'}" height="500" v-loading="groupDetailLoading" style="padding:0 20px">
          <el-table-column prop="name" label="服务器名称"></el-table-column>
          <el-table-column prop="version" label="服务器版本" width="120">
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] | versions(ServerVersion) }}
            </template>
          </el-table-column>
          <el-table-column prop="mergeBeforeId" label="合服前服务器ID" />
          <el-table-column prop="mergeAfterId" label="合服后服务器ID" />
          <el-table-column prop="openTimeStr" label="服务器开服时间" width="140" />
          <el-table-column prop="status" label="服务器状态" width="140">
            <template slot-scope="scope">
              <span v-if="isBdc" :class="serverStatusTagClass(scope.row[scope.column.property])">{{ scope.row[scope.column.property] | statuss(ServerState) }}</span>
              <template v-else>{{ scope.row[scope.column.property] | statuss(ServerState) }}</template>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page="groupDetailPagination.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="groupDetailPagination.pageSize" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="groupDetailPagination.totalSize" style="margin-top:10px;" @size-change="detailSizeChange" @current-change="detailCurrentChange" />

        <div slot="footer">
          <el-button type="primary" @click="groupDetailVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 添加服务器 -->
      <el-dialog append-to-body title="添加服务器" :visible.sync="adddivif" width="400px" top="10vh" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="form" label-width="140px">
          <el-form-item label="服务器名称">
            <el-input v-model="form.name" style="width:200px" maxlength="150" placeholder="请输入服务器名称" />
          </el-form-item>
          <el-form-item label="服务器版本">
            <el-select v-model="form.version" style="width:200px">
              <el-option v-for="selectvalue in ServerVersion" :key="selectvalue.text" :label="selectvalue.text" :value="selectvalue.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="合服前服务器ID">
            <el-input v-model="form.mergeBeforeId" style="width:200px" placeholder="100字内小写字母加下划线" />
          </el-form-item>
          <el-form-item label="合服后服务器ID">
            <el-input v-model="form.mergeAfterId" style="width:200px" placeholder="100字内小写字母加下划线" />
          </el-form-item>
          <el-form-item label="开服时间">
            <el-date-picker v-model="form.openTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器开服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="关服时间">
            <el-date-picker v-model="form.closeTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器关服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="合服时间">
            <el-date-picker v-model="form.mergeTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器合服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="服务器状态">
            <el-radio-group v-model="form.status">
              <el-radio v-for="selectvalue in ServerState" :key="selectvalue.text" :label="selectvalue.value">{{ selectvalue.text }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmit">立即创建</el-button>
            <el-button @click="hidedivshow">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑服务器 -->
      <el-dialog append-to-body title="编辑服务器" :visible.sync="updatedivif" width="400px" top="10vh" :close-on-click-modal="false">
        <el-form ref="form" :inline="true" :model="uform" label-width="140px">
          <el-form-item label="服务器名称">
            <el-input v-model="uform.name" style="width:200px" maxlength="150" placeholder="请输入服务器名称" />
          </el-form-item>
          <el-form-item label="服务器版本">
            <el-select v-model="uform.version" style="width:200px">
              <el-option v-for="selectvalue in ServerVersion" :key="selectvalue.text" :label="selectvalue.text" :value="selectvalue.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="合服前服务器ID">
            <el-input v-model="uform.mergeBeforeId" style="width:200px" placeholder="100字内小写字母加下划线" />
          </el-form-item>
          <el-form-item label="合服后服务器ID">
            <el-input v-model="uform.mergeAfterId" style="width:200px" placeholder="100字内小写字母加下划线" />
          </el-form-item>
          <el-form-item label="开服时间">
            <el-date-picker v-model="uform.openTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器开服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="关服时间">
            <el-date-picker v-model="uform.closeTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器关服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="合服时间">
            <el-date-picker v-model="uform.mergeTimeStr" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="服务器合服时间" style="width:200px;" />
          </el-form-item>
          <el-form-item label="服务器状态">
            <el-radio-group v-model="uform.status">
              <el-radio v-for="selectvalue in ServerState" :key="selectvalue.text" :label="selectvalue.value">{{ selectvalue.text }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-top:30px;">
            <el-button style="margin-left:50px;" type="primary" @click="onSubmituform">保存修改</el-button>
            <el-button @click="hidedivshowuform">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 批量编辑运营渠道 -->
      <el-dialog append-to-body class="batch-upload" title="批量编辑-上传文件" :visible.sync="batchDia" :width="JSON.stringify(uploadRecord) == '{}' ? '700px' : '420px'" :close-on-click-modal="false">
        <template v-if="JSON.stringify(uploadRecord) == '{}'">
          <div style="font-size: 14px;margin-bottom: 16px;">
            <span style="margin-right: 18px;color: #666666;">第一步:</span>
            <span style="margin-right: 3px;color: #333;">下载<el-link :underline="false" type="primary" @click="downloadTemplate">《区服名称批量上传格式模板》</el-link></span>
          </div>
          <div style="font-size: 14px;margin-bottom: 12px;">
            <span style="margin-right: 18px;color: #666666;">第二步:</span>
            <span style="margin-right: 3px;color: #333;">上传填写好的模板</span>
          </div>
          <div style="padding-left: 70px">
            <!-- 文件上传  -->
            <el-upload v-show="fileList.length == 0" ref="upload" class="file-upload" :show-file-list="false" :auto-upload="false" accept=".xls,.xlsx" :headers="uploadHeaders" :action="actionUrl" :limit="1" :with-credentials="false" :on-change="loadFile" :on-exceed="onExceed" :on-success="loadSuccess" :file-list="fileList">
              <el-button size="mini" style="padding: 5px 12px;">
                <svg-icon icon-class="upload" style="width: 16px;height: 16px;margin-right: 4px;" />
                上传文件
              </el-button>
            </el-upload>

            <!-- 已上传文件列表  -->
            <div v-show="fileList.length != 0" class="uploaded-file">
              <div class="file">
                <svg-icon class="file-svg" icon-class="file" />
                <span class="file-name">{{ fileList[0] ? fileList[0].name : '' }}</span>
              </div>
              <div class="handle">
                <i class="el-icon-circle-check right-svg success-svg" />
                <i class="el-icon-close right-svg handle-svg" @click="deleteFile" />
              </div>
            </div>
            <div style="margin-top: 12px;">
              <span style="color: #999999">仅支持xls、xlsx格式文件，最多可上传一个文件</span>
            </div>
            <div style="margin: 12px 0px 20px 0px;width: 564px;background: rgba(255,150,62,0.1);border-radius: 6px;border: 1px solid rgba(255,150,62,0.1);color: #FF963E;padding: 5px 44px;position: relative">
              <i class="el-icon-warning" style="font-size: 16px;position: absolute;top: 8px;left: 16px;" />
              <div style="line-height: 22px">
                1.只支持修改【服务器名称】这1个字段，存在重复数据时以第一条为准</br>
                2. 第一列为空的数据无法解析，上传记录数不会统计该条数据
              </div>
            </div>
          </div>

          <div slot="footer">
            <el-button @click="cancelBatch">取消</el-button>
            <el-button style="margin-left:12px;" type="primary" @click="handleBatch">上传</el-button>
          </div>
        </template>

        <!--  上传成功  -->
        <div v-else class="success-block">
          <svg-icon icon-class="success" class="item-icon" style="width: 56px;height: 56px;" />
          <div class="success-title">上传成功</div>
          <div class="success-detail">
            <div class="detail-block">
              <span class="detail-title">上传记录数：</span>
              <span class="detail-text">{{ uploadRecord.totalSize }}</span>
            </div>
            <div class="detail-block">
              <span class="detail-title">成功导入数：</span>
              <span class="detail-text">{{ uploadRecord.successSize }}</span>
            </div>
            <div class="detail-block" style="display: flex">
              <span class="detail-title">失败行数：</span>
              <span class="detail-text">{{ uploadRecord.errorSize }}</span>
              <el-link type="primary" :underline="false" :href="uploadRecord.url" style="margin-left: 16px">下载失败明细 ></el-link>
            </div>
          </div>
          <div style="display: flex;width: 100%;justify-content: flex-end;margin-top: 40px">
            <el-button type="primary" @click="cancelBatch">完成</el-button>
          </div>
        </div>
      </el-dialog>

    </div>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcDownloadButton from '@/components/BdcTableFooter/BdcDownloadButton'
import {
  queryServerList,
  syncServerData,
  saveServer,
  updateServer,
  deleteServerById,
  queryServerVersionList,
  queryServerStateList,
  queryServerGroups,
  queryServerGroupsPost,
  queryServerGroupsPut,
  queryServerGroupsDelete,
  queryServerGroupsIdServers,
  queryServerGroupsRebuild
} from '@Bdc~/api/ajax_model'
import DatePicker from '@Sys~/components/DatePicker'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { apiUrl } from '../../api/env'
import store from '@Sys~/store'

import bdcTableCrosshair from '@Bdc~/utils/bdcTableCrosshair'

export default {
  name: '',
  components: { DatePicker, Pagination, BdcTableFooter, BdcDownloadButton },
  mixins: [bdcTableCrosshair],
  filters: {
    versions(value, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i].value) {
          return arr[i].text
        }
      }
    },
    statuss(value, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i].value) {
          return arr[i].text
        }
      }
    }
  },
  data() {
    return {
      listLoading: false,
      batchDia: false, // 批量编辑弹窗
      uploadRecord: {}, // 上传后的状态 成功还是失败
      // 上传携带头部信息
      uploadHeaders: {
        'appkey': store.getters.appkey
      },
      // 上传后台地址
      actionUrl: apiUrl.gateUrl + '/api/server/import/update',
      // 上传的文件列表
      fileList: [],
      form: {
        appkey: this.$store.getters.appkey,
        gameId: '',
        name: '',
        version: '',
        mergeBeforeId: '',
        mergeAfterId: '',
        openTimeStr: '',
        closeTimeStr: '',
        mergeTimeStr: '',
        status: '0'
      },
      uform: {
        id: '',
        appkey: '',
        gameId: '',
        name: '',
        version: '',
        mergeBeforeId: '',
        mergeAfterId: '',
        openTimeStr: '',
        closeTimeStr: '',
        mergeTimeStr: '',
        status: ''
      },
      tongbuloading: false,
      adddivif: false,
      updatedivif: false,
      eventdivif: false,
      dialogTableVisible: false,
      adddivifcanshu: false,
      updatedivifcanshu: false,
      shijianxiangqing: '',

      ServerState: [],
      ServerVersion: [],
      ServerVersions: '',
      ServerStates: '',
      serverNames: '',
      oldtimes: null,
      times: '',

      zdydialogTableVisible: false,
      zdyshijianxiangqing: '',

      tableData: [],
      currentPage: 1,
      dataLength: 1,
      sizePage: 10,

      groupLoading: false,
      groupBuildLoading: false,
      groupNames: '',
      groupTableData: [],
      groupDialogVisible: false,
      groupRules: {
        groupName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        serverIdStart: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        serverIdEnd: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      groupForm: {
        appkey: this.$store.getters.appkey,
        id: '',
        groupName: '',
        serverIds: []
      },
      pagination: {
        pageNo: 1,
        pageSize: 10,
        totalSize: 0
      },
      groupOptLoading: false,
      groupDetailVisible: false,
      groupDetailLoading: false,
      groupDetailTitle: '区服详情',
      groupDetailId: null,
      groupDetailPagination: {
        pageNo: 1,
        pageSize: 10,
        totalSize: 0
      },
      groupDetailTableData: [],


    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    currentGame() {
      return this.$store.getters.gameOptions.find(item => item.appkey == this.$store.getters.appkey)
    }
  },
  created() {
    this.queryServerList()
    this.queryServerVersionList()
    this.queryServerStateList()
    //分组相关
    this.queryGroupList()
  },
  mounted() { },
  methods: {
    serverStatusTagClass(status) {
      const matched = this.ServerState.find(item => String(item.value) === String(status))
      const text = matched ? matched.text : ''
      if (text.indexOf('开服') !== -1) {
        return 'bdc-label-tag bdc-label-tag--green'
      }
      if (text.indexOf('停服') !== -1 || text.indexOf('关服') !== -1) {
        return 'bdc-label-tag bdc-label-tag--gray'
      }
      return 'bdc-label-tag bdc-label-tag--gray'
    },
    queryServerList() {
      this.listLoading = true
      queryServerList(
        this.serverNames,
        this.ServerVersions,
        this.times,
        this.ServerStates
      ).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.listLoading = false
          this.tableData = response.data
          this.dataLength = response.data.length
          if (this.dataLength > 0) {
            this.form.gameId = this.tableData[0].gameId
          }
        }
      })
    },

    queryServerVersionList() {
      // 版本列表
      queryServerVersionList().then(response => {
        console.log(response)
        if (response.code == 1) {
          this.ServerVersion = response.data
        }
      })
    },
    queryServerStateList() {
      // 状态列表
      queryServerStateList().then(response => {
        console.log(response)
        if (response.code == 1) {
          this.ServerState = response.data
        }
      })
    },
    zidingyishijianupdate(index, row) {
      console.log(row)
      this.updatedivif = true
      row.status = row.status + ''
      row.version = row.version + ''
      this.uform = JSON.parse(JSON.stringify(row))
    },
    zidingyishijiandelete(index, row) {
      this.$confirm('确认删除 "' + row.name + '" 吗？')
        .then(_ => {
          console.log(row)
          deleteServerById(row.id).then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.queryServerList()
            }
          })
        })
        .catch(_ => { })
    },
    filterplatformType(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters)
      if (filters.version) {
        if (filters.version.length > 0) {
          this.ServerVersions = filters.version[0]
        } else {
          this.ServerVersions = ''
        }
      }

      if (filters.status) {
        if (filters.status.length > 0) {
          this.ServerStates = filters.status[0]
        } else {
          this.ServerStates = ''
        }
      }
      this.queryServerList()
    },

    shaixuanServerVersions(e) {
      this.ServerVersions = e
      this.queryServerList()
    },
    shaixuanServerStates(e) {
      this.ServerStates = e
      this.queryServerList()
    },
    mohuchaxun() {
      this.currentPage = 1
      this.oldtimes = this.$refs.datepicker.selectdate
      console.log(this.oldtimes)
      if (this.oldtimes && this.oldtimes.length > 0) {
        var ts = this.oldtimes
        this.times = ts[0] + ' - ' + ts[1]
      } else {
        this.times = ''
      }
      this.queryServerList()
    },
    onSubmit() {
      // 添加自定义事件
      console.log(this.form)
      saveServer(this.form).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.queryServerList()
          this.adddivif = false
        }
      })
    },
    onSubmituform() {
      // 修改自定义事件
      console.log(this.uform)
      updateServer(this.uform).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.queryServerList()
          this.updatedivif = false
        }
      })
    },
    tongbuqufu() {
      this.tongbuloading = true
      syncServerData().then(response => {
        console.log(response)
        if (response.code == 1) {
          this.$message({
            message: response.data,
            type: 'success'
          })
          this.queryServerList()
        }
        this.tongbuloading = false
      })
    },

    adddivshow() {
      this.form = {
        appkey: this.$store.getters.appkey,
        gameId: '',
        name: '',
        version: '',
        mergeBeforeId: '',
        mergeAfterId: '',
        openTimeStr: '',
        closeTimeStr: '',
        mergeTimeStr: '',
        status: '0'
      }
      this.adddivif = true
    },
    hidedivshow() {
      this.adddivif = false
    },
    hidedivshowuform() {
      this.updatedivif = false
    },
    hidedivshowcanshuadd() {
      this.adddivifcanshu = false
    },
    handleSizeChange(e) {
      // table 分页数量变化
      this.sizePage = e
    },
    handleCurrentChange(e) {
      // table 分页变化
      this.currentPage = e
    },
    handleSizeChange1(e) {
      // table 分页数量变化
      this.sizePage1 = e
    },
    handleCurrentChange1(e) {
      // table 分页变化
      this.currentPage1 = e
    },
    handleSizeChange2(e) {
      // table 分页数量变化
      this.sizePage2 = e
    },
    handleCurrentChange2(e) {
      // table 分页变化
      this.currentPage2 = e
    },
    handleSizeChange3(e) {
      // table 分页数量变化
      this.sizePage3 = e
    },
    handleCurrentChange3(e) {
      // table 分页变化
      this.currentPage3 = e
    },
    handleSizeChange4(e) {
      // table 分页数量变化
      this.sizePage4 = e
    },
    handleCurrentChange4(e) {
      // table 分页变化
      this.currentPage4 = e
    },
    // 下载模板
    downloadTemplate() {
      // 创建一个<a></ a>标签
      const a = document.createElement('a')
      a.href = '/区服名称批量上传格式模板.xlsx'
      a.download = '区服名称批量上传格式模板.xlsx'

      // 障眼法藏起来a标签
      a.style.display = 'none'
      // 将a标签追加到文档对象中
      document.body.appendChild(a)
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click()
      // 一次性的,用完就删除a标签
      a.remove()
    },

    // 批量编辑
    batchEdit() {
      this.batchDia = true
      this.fileList = []
      this.uploadRecord = {}
    },

    // 取消批量弹窗
    cancelBatch() {
      this.fileList = []
      this.batchDia = false
    },

    // 确定上传
    handleBatch() {
      if (this.fileList.length) {
        this.$refs.upload.submit()
      } else {
        this.$message({ type: 'warning', message: '请上传文件' })
      }
    },

    // 删除已上传的文件
    deleteFile() {
      this.fileList = []
    },

    // 加载文件内容
    loadFile(file, fileList) {
      if (!file.name.endsWith('.xls') && !file.name.endsWith('.xlsx')) {
        this.$message({ type: 'error', message: '仅支持上传xls或xlsx格式文件，请修改后上传' })
        this.$refs.upload.clearFiles()
      }
      this.fileList = fileList
    },

    // 重新上传的文件
    onExceed(file, fileList) {
      // this.$refs['upload'].clearFiles()// 清除文件
      // this.$refs['upload'].handleStart(file[0])// 选择文件后的赋值方法
    },

    // 文件上传成功
    loadSuccess(res, file, fileList) {
      if (res.code == 1) {
        this.uploadRecord = res.data
      } else {
        this.$message({ type: 'error', message: res.msg || '上传失败' })
        this.$refs.upload.clearFiles()
      }
    },
    exportExcel(e) {
      const gameName = store.getters.gameOptions.find(item => item.appkey == store.getters.appkey).name
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(
        document.querySelector('#xiazaishijian')
      )
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          gameName + '_区服文件.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
    //查询分组
    queryGroupList() {
      this.groupLoading = true
      let params = {
        appkey: this.$store.getters.appkey,
        groupName: this.groupNames
      }
      queryServerGroups(params).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.groupLoading = false
          this.groupTableData = response.data
          this.pagination.totalSize = response.data.length
        }
      })
    },
    //跟新分组数据分组
    queryGroupListRebuild() {
      this.groupBuildLoading = true
      let params = {
        appkey: this.$store.getters.appkey,
      }
      queryServerGroupsRebuild(params).then(response => {
        if (response.code == 1) {
          this.$message({
            message: response.data,
            type: 'success'
          })
          this.queryGroupList()
        }
        this.groupBuildLoading = false
      })
    },
    groupSizeChange(e) {
      // table 分页数量变化
      this.pagination.pageSize = e
    },
    groupCurrentChange(e) {
      // table 分页变化
      this.pagination.pageNo = e
    },
    editGroup(row) {
      console.log(row)
      if (row) {
        this.groupForm = {
          appkey: this.$store.getters.appkey,
          id: row.id,
          groupName: row.groupName,
          groupType: row.groupType,
          serverIdStart: row.serverIdStart,
          serverIdEnd: row.serverIdEnd,
          updateUserId: this.$store.getters.userId,
          updateUserName: this.$store.getters.realName
        }
      } else {
        this.groupForm = {
          appkey: this.$store.getters.appkey,
          groupName: "",
          groupType: 1,
          serverIdStart: undefined,
          serverIdEnd: undefined,
          createUserId: this.$store.getters.userId,
          createUserName: this.$store.getters.realName,
          updateUserId: this.$store.getters.userId,
          updateUserName: this.$store.getters.realName
        }
      }
      this.groupDialogVisible = true
      this.groupOptLoading = false
      this.$nextTick(() => {
        this.$refs['groupForm'].clearValidate()
      })

    },
    submitGroup() {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.groupOptLoading = true

          let p = this.groupForm.id ? this.editGroupFun(this.groupForm.id, this.groupForm) : this.createGroupFun(this.groupForm)

          p.then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message({
                message: this.groupForm.id ? '编辑成功' : '新建成功',
                type: 'success'
              })
              this.queryGroupList()
              this.groupDialogVisible = false
            }
            this.groupOptLoading = false
          })
        }
      });


    },
    createGroupFun(params) {
      return new Promise((resolve, reject) => {
        queryServerGroupsPost(params).then(res => {
          resolve(res)
        })
      })
    },
    editGroupFun(id, params) {
      return new Promise((resolve, reject) => {
        queryServerGroupsPut(id, params).then(res => {
          resolve(res)
        })
      })
    },
    deleteGroup(row) {
      this.$confirm('确认删除 "' + row.groupName + '" 吗？')
        .then(_ => {
          queryServerGroupsDelete(row.id).then(response => {
            console.log(response)
            if (response.code == 1) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.queryGroupList()
            }
          })
        })
        .catch(_ => { })
    },
    serverDetail(row) {
      this.groupDetailTitle = '区服详情: ' + row.groupName
      this.groupDetailVisible = true
      this.groupDetailPagination.pageNo = 1
      this.groupDetailId = row.id
      this.queryGroupServer(this.groupDetailId)
    },
    queryGroupServer(id) {
      this.groupDetailLoading = true
      queryServerGroupsIdServers(id, { appkey: this.$store.getters.appkey, pageNo: this.groupDetailPagination.pageNo, pageSize: this.groupDetailPagination.pageSize }).then(response => {
        if (response.code == 1) {
          this.groupDetailLoading = false
          this.groupDetailTableData = response.data.result
          this.groupDetailPagination.totalSize = response.data.totalCount
        }
      })
    },
    detailSizeChange(e) {
      // table 分页数量变化
      this.groupDetailPagination.pageSize = e
      this.groupDetailPagination.pageNo = 1
      this.queryGroupServer(this.groupDetailId)
    },
    detailCurrentChange(e) {
      // table 分页变化
      this.groupDetailPagination.pageNo = e
      this.queryGroupServer(this.groupDetailId)
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.tb-edit2 tr td {
  padding: 0px 0px;
  height: 40px;
  line-height: 40px;
}
.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.more-dropdown {
  margin-top: 4px !important;
  border-radius: 8px;
  ::v-deep .popper__arrow {
    display: none;
  }
  ::v-deep .el-dropdown-menu__item {
    color: #333333;
  }
  ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    background: #ebf3ff;
    color: #333333;
  }
}

.batch-upload {
  ::v-deep .el-dialog__body {
    padding: 15px 32px;
  }
}

.uploaded-file {
  width: 500px;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 0;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: rgba(58, 137, 255, 0.1);
    .success-svg {
      display: none;
    }
    .handle-svg {
      display: block;
    }
  }

  .file {
    display: flex;
    align-items: center;
    .file-svg {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
  }
  .right-svg {
    font-size: 20px;
    float: right;
  }
  .success-svg {
    color: #3a89ff;
    display: block;
  }
  .handle-svg {
    cursor: pointer;
    display: none;
  }
}

.success-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0px 10px;
  .success-title {
    font-size: 16px;
    margin: 8px 0px 24px 0px;
    color: #333333;
  }

  .success-detail {
    padding: 12px 16px;
    width: 100%;
    line-height: 22px;
    background: #f9f9f9;
    border: 1px solid #e5e5e5;
    .detail-block + .detail-block {
      margin-top: 4px;
    }
    .detail-title {
      color: #666666;
    }
    .detail-text {
      color: #333333;
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
body:not(.bdc-app-body) .el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
.tip-group {
  font-size: 13px;
  color: #888;
  margin: 0 20px;
  line-height: 20px;
  letter-spacing: 0.6px;
}
.tip-icon {
  margin-right: 5px;
}
</style>
